module.exports = __webpack_public_path__ + "static/media/Group 7007.4f116099.svg";